// A screenshot taken from the nav, waiting for the Messages page to pick up.
//
// Taken BEFORE navigating, which is the whole point of starting from the nav:
// the screen somebody is stuck on is the one they are looking at, and a
// screenshot taken after a trip to Messages would be of Messages. Held here
// rather than in router state so a reload does not offer it again, and taken
// exactly once.

let pending: File | null = null;

export function handOffScreenshot(file: File): void {
  pending = file;
}

export function takeHandedOffScreenshot(): File | null {
  const file = pending;
  pending = null;
  return file;
}
